module.exports = __webpack_public_path__ + "img/up-vacanta-up-online.0974d4a7.png";